import { get } from '../server';
import { urls, TYPE } from '../reducers/seoFooterLinks';
import { getSections, getIsError, getIsFetching, getErrorsMetadata } from 'Selectors/seo';
import { getSeoFooterURL, getSeoConfigParams } from 'Helpers/seo';
import { getSEOLang } from 'Selectors/config';
import { shouldRetry } from 'Helpers/ssrRetry';

export const getFooterLinks = (config, params, reqProps, retrySSRFailed) => (dispatch, getState) => {
    const type = `ELEMENT_${TYPE}`;
    const state = getState();
    const lang = getSEOLang(state);
    const url = getSeoFooterURL(config, urls);

    params = params ? { ...getSeoConfigParams(config, lang), ...params } : getSeoConfigParams(config, lang);

    const isError = getIsError(state, url, params);
    const isFetching = getIsFetching(state, url, params);
    const errorMetadata = getErrorsMetadata(state, url, params);
    const sections = getSections(state, url, params);
    const retry = retrySSRFailed && shouldRetry(errorMetadata);

    if (isFetching || sections || (isError && !retry)) {
        return Promise.resolve();
    }

    if (reqProps) {
        return dispatch(get(`${reqProps.baseUrl}${url}`, type, params, reqProps.headers));
    }

    return dispatch(get(url, type, params));
};
